import './myInfo.css';
import styled from '@emotion/styled';
import { yupResolver } from '@hookform/resolvers/yup';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';

import { useEffect } from 'react';
import { useAlert } from 'react-alert';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { URL } from '../../constants/userConstants';
import { API } from '../../actions/userAction';

const Err = styled.p`
  color: red;
`;

export function MyInfo() {
  const { user } = useSelector((state) => state.user);
  const alert = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    setValue('username', user?.username);
    setValue('phoneNumber', user?.phonenumber);
  }, [user]);

  const validationSchema = Yup.object().shape({
    username: Yup.string()
      .required('Username is required')
      .min(3, 'Username must be at least 3 characters')
      .max(20, 'Username must not exceed 20 characters'),

    phoneNumber: Yup.string()
      .required('Phone Number is required')
      .matches(/^[0-9]+$/, 'Only numbers allowed')
      .length(10, 'Phone Number must be 10 digits'),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (formData) => {
    try {
      const data = await API.put(
        `${URL}/auth/updateProfile/${user?._id}`,
        {
          username: formData.username,
          phoneNumber: formData.phoneNumber,
        }
      );

      alert.success(data.data.message);
    } catch (error) {
      alert.error('Update failed');
    }
  };

  return (
    <div className="infoContainer">
      <div className="infoBody">
        <div className="myInfoTop">
          <ArrowBackIcon
            style={{ marginRight: '20px' }}
            onClick={() => navigate(-1)}
          />
          My Info and Settings
        </div>

        <div className="myInfo">
          <form onSubmit={handleSubmit(onSubmit)} className="myInfoForm">

            <TextField
              required
              label="Name"
              variant="standard"
              fullWidth
              margin="dense"
              InputLabelProps={{ shrink: true }}
              {...register('username')}
              error={!!errors.username}
            />
            <Typography color="error">
              {errors.username?.message}
            </Typography>

            <TextField
              required
              label="Phone Number"
              variant="standard"
              fullWidth
              margin="dense"
              InputLabelProps={{ shrink: true }}
              {...register('phoneNumber')}
              error={!!errors.phoneNumber}
            />
            <Typography color="error">
              {errors.phoneNumber?.message}
            </Typography>

            <Button
              variant="contained"
              type="submit"
              disableElevation
              style={{
                backgroundColor: 'var(--red)',
                marginTop: '15px',
              }}
            >
              Update
            </Button>

          </form>
        </div>
      </div>
    </div>
  );
}

export default MyInfo;
